<template>
    <div id="documents">
        <!--Contrats-->
        <div id="contrat" class="typeDocument">
          <div v-if="contracts.length">
            <b-table class="text-center" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFilteredContracts" responsive :striped="true" :fields="fieldsContrats" :items="contracts" :current-page="currentPageContrats" :per-page="perPage">
              <template v-slot:cell(date-signature)="data">
                <span style='font-size:14px;'>{{ data.item.date_signature }}</span>
              </template>
              <template v-slot:cell(date-service)="data">
                <span style='width:30%; font-size:14px; text-transform: uppercase;'>{{ data.item.date_effective }}</span>
              </template>
              <!-- <template v-slot:cell(date-fin-contrat)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.address }}</span>
              </template> -->
              <template v-slot:cell(type)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.ref_customer }}</span>
              </template>
              <template v-slot:cell(prix-ht)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.total_ht }}</span>
              </template>
              <template v-slot:cell(prix-ttc)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.total_ttc }}</span>
              </template>
              <template v-slot:cell(document)="data">
                <span style='font-size:14px; text-transform: uppercase;'>{{ data.item.ref+'.pdf' }}</span>
              </template>
             <template v-slot:cell(download)="data">
                <a v-bind:href="'/api/downloadDoc/contract/'+data.item.ref+'/'+data.item.ref+'.pdf'" download><span style="cursor:pointer;" class='fas fa-cloud-download-alt' v-b-tooltip.hover title='Télécharger'></span></a>
              </template>
              <template v-slot:cell(visual)="data">
                <a v-on:click.stop="visualDocClient(data.item)"><span style="cursor:pointer;" class='far fa-eye' v-b-tooltip.hover title='Visualiser'></span></a>
              </template>
              <!--<template v-slot:cell(comment)="data">
                <a v-on:click.stop="commentDoc(data.item.rowid)"><span style="cursor:pointer;" class='fas fa-comment-alt' v-b-tooltip.hover title='Commentaire'></span>
              </template>-->
            </b-table>
            <div v-if="contracts.length>perPage">
              <b-pagination size="md" :total-rows="contracts.length" v-model="currentPageContrats" :per-page="perPage" />
            </div>
          </div>
          <div v-else>
            <h5>Aucuns contrats disponibles</h5>
          </div>
        </div>    
      <b-modal id="modalVisualContrats" @hide="resetModal" :title="modalVisual.title" hide-footer>
        <template>
          <iframe id="visualDoc" v-bind:src="visualSrc"></iframe>
        </template>
      </b-modal>
  
    </div>
  </template>
  
  <style>
  #documents{
    margin: auto;
    width: 100%;
    text-align: center;
  }
  
  #contrat > h3, #contrat .table thead th, #contrat .table td,#contrat .table th{
    border-color: #3C4694;
  }
  
  #devis > h3, #devis .table thead th, #devis .table td,#devis .table th{
    border-color: #6D3D94;
  }
  
  #commande > h3, #commande .table thead th, #commande .table td,#commande .table th{
    border-color: #ED2C74;
  }
  
  #facture > h3, #facture .table thead th, #facture .table td,#facture .table th{
    border-color: #00B7A7;
  }
  
  #documents .input-group{
    width: 60%;
  }
  
  #documents .input-group>.form-control{
    flex: 1 1 50%;
  }
  
  #visualDoc{
    width: 100%;
    height: 100%;
  }
  
  #modalVisualContrats .modal-dialog {
    max-width: 50%;
    height: 95%;
    margin-top: 1%;
  }
  
  #modalVisualContrats .modal-body {
    max-height: 90%;
    padding: 0;
    overflow: unset;
  }
  
  #modalVisualContrats .modal-dialog > div{
    height: 100%;
  }
  
  </style>
  
  <script>
  import script from '../../../script/script.js';
  
  export default {
    data() {
      return {
        post: {},
        fieldsContrats:[{key:"date-signature", label:"Date de signature"},{key:"date-service", label:"Date de mise en service"},/*{key:"date-fin-contrat", label:"Date de fin de contrat"},*/{key:"type", label:"Type de contrat"},{key:"prix-ht", label:"Total(ht*)"},{key:"prix-ttc", label:"Total(ttc*)"},{key:"document", label:"Document"},{key:"download", label:""},{key:"visual", label:""}/*,{key:"comment", label:""}*/],
        currentPageContrats: 1,
        perPage: 10,
        totalRows:{
          contracts:0,
          orders:0,
          proposals:0,
          invoices:0,
        },
        modalVisual: { title: '', content: '' },
        visualSrc:''
      }
    },
    mounted:function(){
      this.$store.commit("resetDocuments")
      this.loadDocuments("contracts");
    },
    methods: {
      loadDocuments: script.loadDocuments,
      visualDocClient: script.visualDocClient,
      commentDoc: script.commentDoc,
    },
    components: {
  
    },
    computed: {
      contracts(){
        return this.$store.state.contracts
      },
    }
  }
  </script>
  